import './home.css'

function HomePage(){
    
    
    return (
        <div className="title-container">
            <div className='text-center'>
                <h1>Welcome to Typing Games</h1>
                
                <a href='./play' >Click here to play !</a> 
            </div>
            
        </div>
    )
}

export default HomePage